/**
 * Validation rules configuration for form inputs
 * Each rule defines constraints for validating field values
 */
export const VALIDATION_RULES = {
    currentAge: {
        type: 'number',
        min: 18,
        max: 99,
        required: true
    },
    retirementAge: {
        type: 'number',
        min: 18,
        max: 99,
        required: true
    },
    currentComp: {
        type: 'number',
        min: 0,
        required: true,
        customValidation: (value) => value > 0
    },
    compRate: {
        type: 'number',
        min: 0,
        required: true
    },
    catchUpAmount: {
        type: 'number',
        min: 0,
        required: true,
        // max will be set dynamically from props
        usePropForMax: 'MaxCatchUpContribution'
    },
    deferralPercentage: {
        type: 'number',
        min: 0,
        required: true
    },
    est401Return: {
        type: 'number',
        min: 0,
        required: true
    },
    beginningSharesHeld: {
        type: 'number',
        min: 0,
        required: true
    },
    assumedPercentageIncreaseShares: {
        type: 'number',
        min: 0,
        required: true
    },
    assumedPercentageIncreaseDividends: {
        type: 'number',
        min: 0,
        required: true
    },
    assumedPercentageIncreaseCash: {
        type: 'number',
        min: 0,
        required: true
    }
};